import Plyr from 'plyr';

class EditorialVideos {
    constructor () {
        this.players = [];
    }

    init () {
        this.players = Array.from(document.querySelectorAll('.js-editorial-video-player'))
            .map((p) => {
                const ratio = $(p).data('video-ratio');
                const autoplay = $(p).data('autoplay');
                const muted = $(p).data('muted');
                const loop = $(p).data('loop');
                const controls = $(p).data('controls');
                const sourceMobile = $(p).data('src-mobile');
                const sourceDesktop = $(p).data('src-desktop');
                const poster = $(p).data('poster');
                const iframe = p.querySelector('iframe');
                if (sourceMobile || sourceDesktop) {
                    if (window.innerWidth >= 1024) {
                        iframe.src = sourceDesktop;
                    } else {
                        iframe.src = sourceMobile;
                    }
                }
                
                if (sourceDesktop === 'undefined' && sourceMobile === 'undefined') {
                    iframe.style.display = 'none';

                    if (poster) {
                        p.style.backgroundImage = `url('${poster}')`;
                        p.style.backgroundSize = 'cover';
                        p.style.backgroundPosition = 'center';
                        p.style.width = '100%';
                        p.style.height = '100%';
                    }
                }

                return new Plyr(p, {
                    controls: controls ? ['mute', 'play'] : false,
                    autoplay: autoplay ? autoplay : false,
                    muted: muted ? muted : false,
                    resetOnEnd: true,
                    ratio: ratio,
                    loop: { active: loop },
                    poster: poster ? poster : null
                });
            });
    }
}

const editorialVideos = new EditorialVideos;
export default editorialVideos;
